import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from './Components/Footer';
import Navbar from './Components/Navbar';
import Home from './Pages/Home';
import NotFound from './Pages/NotFound';
import SingleMovie from './Pages/SingleMovie';
import Favourites from './Pages/SeeLater';
import MoviePlayer from './Components/MoviePlayer/MoviePlayer';
import AuthPage from './Pages/AuthPage';
import MovieListPage from './Components/MovieList/MovieListPage';
import About from './Components/About/About';
import UserProfile from './Components/UserProfile';
import AdminDashboard from './Pages/admin/AdminDashboard';
import MovieAdd from './Pages/admin/MovieAdd';
import MovieEdit from './Pages/admin/MovieEdit';
import UserEdit from './Pages/admin/UserEdit';
import GenreManagement from './Pages/admin/GenreManagement';
import ProtectedAdminRoute from './utils/ProtectedAdminRoute';

function App() {
  const [watchList, setWatchList] = useState(JSON.parse(localStorage.getItem('watchList')) || []);

  return (
    <div className='App'>
      <BrowserRouter>
        <Navbar watchList={watchList} />
        <Routes>
          <Route path='/' element={<Home setWatchList={setWatchList} watchList={watchList} />} />
          <Route path='/movie/:id' element={<SingleMovie />} />
          <Route path='/xem-sau' element={<Favourites watchList={watchList} setWatchList={setWatchList} />} />
          <Route path="/watch/:id" element={<MoviePlayer />} />
          <Route path="/thong-tin-nguoi-dung" element={<UserProfile />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/movies" element={<MovieListPage />} />
          <Route path="/gioi-thieu" element={< About />} />

          <Route path="/admin" element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          } />
          <Route path="/admin/genres" element={
            <ProtectedAdminRoute>
              <GenreManagement />
            </ProtectedAdminRoute>
          } />
          <Route path="/admin/movie/add" element={
            <ProtectedAdminRoute>
              <MovieAdd />
            </ProtectedAdminRoute>
          } />
          <Route path="/admin/movie/edit/:id" element={
            <ProtectedAdminRoute>
              <MovieEdit />
            </ProtectedAdminRoute>
          } />
          <Route path="/admin/user/edit/:id" element={
            <ProtectedAdminRoute>
              <UserEdit />
            </ProtectedAdminRoute>
          } />
          <Route path='*' element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
